/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_BackInputs */

const cs_auth_forgot_back = /** @type {(inputs: Auth_Forgot_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpět na přihlášení`)
};

const en_auth_forgot_back = /** @type {(inputs: Auth_Forgot_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to sign in`)
};

/**
* | output |
* | --- |
* | "Back to sign in" |
*
* @param {Auth_Forgot_BackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_back = /** @type {((inputs?: Auth_Forgot_BackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_BackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_back(inputs)
	return cs_auth_forgot_back(inputs)
});